/**
 * Copy for the Responder's queue and per-channel policy.
 *
 * The REASON a conversation is waiting is not here: it comes from the server
 * already in plain language, because the server is the only place that knows
 * which of a dozen reason codes applied. Re-wording it here would mean two
 * vocabularies drifting apart.
 */
export const enResponder = {
  'responder.needsYou.title': 'Waiting for you',
  'responder.needsYou.empty': 'Nothing waiting.',
  'responder.needsYou.emptyHint': 'Replies the assistant drafts, and anything it hands over, appear here.',
  'responder.needsYou.send': 'Send',
  'responder.needsYou.discard': 'Discard',
  'responder.needsYou.sending': 'Sending…',
  'responder.needsYou.noDraft': 'It did not write a draft for this one.',
  'responder.needsYou.alreadyHandled': 'Someone else already dealt with this one.',
  'responder.needsYou.failed': 'That did not go through. Nothing was sent.',
  'responder.needsYou.editHint': 'Edit before sending if you want to.',
  'responder.needsYou.handoff': 'Needs you',
  'responder.needsYou.drafted': 'Drafted',
  'responder.needsYou.unnamed': 'A customer',
  'responder.needsYou.openConversation': 'Open the conversation with {name}',
  'responder.needsYou.windowClosedTemplate':
    'Window closed — the 24-hour reply window has passed. Reply with an approved template from the conversation.',
  'responder.needsYou.windowClosedWait':
    'Window closed — the 24-hour reply window has passed. They need to message you again before you can reply.',

  // ── Per-channel mode + the knowledge it answers from (Assistant settings) ──
  'responder.settings.heading': 'Responder',
  'responder.settings.explain':
    'Who answers first on each channel. Off: only your flows and you. Suggest: it drafts, you send. Auto (info): it answers questions on its own and hands anything else to you. Auto (policy): it may also book, send the catalog or discount within the limits you set.',
  'responder.settings.channel.instagram': 'Instagram DM',
  'responder.settings.channel.messenger': 'Messenger',
  'responder.settings.channel.whatsapp': 'WhatsApp',
  'responder.settings.mode.OFF': 'Off',
  'responder.settings.mode.SUGGEST': 'Suggest',
  'responder.settings.mode.AUTO_INFO': 'Auto (info)',
  'responder.settings.mode.AUTO_POLICY': 'Auto (policy)',
  'responder.settings.modeSaved': 'Saved.',
  'responder.settings.modeFailed': 'Could not save that. Try again.',
  'responder.settings.loadFailed': 'Could not load the Responder settings.',
  'responder.knowledge.heading': 'What it knows',
  'responder.knowledge.explain':
    'Answers come from here. Import a spreadsheet of questions and answers, or add one at a time. Pricing, how to sign up, what the product does — anything a customer asks.',
  'responder.knowledge.importCsv': 'Import questions & answers (CSV)',
  'responder.knowledge.csvHint':
    'Columns: question, answer, and optionally kind. Hebrew headers (שאלה, תשובה) work too. Up to 500 rows.',
  'responder.knowledge.importing': 'Importing…',
  'responder.knowledge.imported': '{imported} added, {duplicates} already there, {skipped} skipped.',
  'responder.knowledge.importFailed': 'That file could not be imported.',
  'responder.knowledge.addTitle': 'Question or title',
  'responder.knowledge.addBody': 'Answer',
  'responder.knowledge.add': 'Add',
  'responder.knowledge.addFailed': 'Could not add that.',
  'responder.knowledge.empty': 'Nothing yet. It will only answer from what is here and from your policies.',
  'responder.knowledge.remove': 'Remove',
  'responder.knowledge.count': '{count} documents',
} as const;
